import { COMPANY_TYPES } from '../../resources/enums';
import { ITeamPaymentAccount } from '../../resources/interfaces';
import { Partner } from '../partner/Partner';
import { IUser, User } from '../User';
import { ICompany } from './ICompany';

export class Company {
  id: string;
  name: string;
  numberOfMembers: number;
  numberOfBranches: number;
  relationshipManager?: User;
  commissionRate?: string;
  summary: any;
  teamLead: string | undefined;
  active: boolean;
  type: COMPANY_TYPES;
  createdOn: Date;
  updatedOn: Date;
  commissionRateComprehensive: number;
  commissionRateThirdParty: number;
  email: string;
  address: string;
  mobilePhone: string;
  corporatePhone: string;
  setupCompleted: boolean;
  paymentAccount: ITeamPaymentAccount;
  logo: string;
  members: User[];
  policyCreationTime?: number;
  partner?: Partner;
  termsAndConditionsAccepted: boolean;
  termsAndConditionsAcceptedBy: string
  termsAndConditionsAcceptedDateAndTime: Date | undefined
  trialExpiry?: string
  insurerId?: string

  constructor(Imodel: ICompany) {
    this.id = Imodel.id;
    this.name = Imodel.name;
    this.numberOfMembers = Imodel.numberOfMembers;
    this.numberOfBranches = Imodel.numberOfBranches;
    this.relationshipManager = Imodel.relationshipManager
      ? new User(Imodel.relationshipManager)
      : undefined;
    this.commissionRate = Imodel.commissionRate;
    this.summary = Imodel.summary;
    this.teamLead = Imodel.teamLead ?? undefined;
    this.active = Imodel.active;
    this.type = Imodel.type;
    this.createdOn = new Date(Imodel.createdOn);
    this.updatedOn = new Date(Imodel.updatedOn);
    this.commissionRateComprehensive = Imodel.commissionRateCP;
    this.commissionRateThirdParty = Imodel.commissionRateTP;
    this.email = Imodel.email;
    this.address = Imodel.address;
    this.mobilePhone = Imodel.mobilePhone;
    this.corporatePhone = Imodel.corporatePhone;
    this.setupCompleted = Imodel.setupCompleted;
    this.paymentAccount = Imodel.paymentAccount;
    this.logo = Imodel.logo;
    this.members = Imodel.members ? Imodel.members?.map((member: IUser) => new User(member)) : [];
    this.policyCreationTime = Imodel.policyCreationTime ?? undefined;
    this.partner = Imodel.partner ? new Partner(Imodel.partner) : undefined;
    this.termsAndConditionsAccepted = Imodel.termsAndConditionsAccepted;
    this.termsAndConditionsAcceptedBy = Imodel.termsAndConditionsAcceptedBy;
    this.termsAndConditionsAcceptedDateAndTime = Imodel.termsAndConditionsAcceptedDateAndTime ? new Date(Imodel.termsAndConditionsAcceptedDateAndTime) : undefined;
    this.trialExpiry = Imodel.trialExpiry;
    this.insurerId = Imodel.insurerId;
  }

  getPolicyCompletionTimeInMinutes(): number | undefined {
    return this.policyCreationTime ? this.policyCreationTime / 1000 : undefined;
  }

  isRidehshare(): boolean {
    return this.type === COMPANY_TYPES.RIDE_SHARING;
  }

  isFuelProvider(): boolean {
    return this.type === COMPANY_TYPES.FUEL_PROVIDER;
  }
}
